module.exports = __webpack_public_path__ + "img/zapatos.2b019451.jpg";